<!-- Expanded queue panel -->
<aside
  class="poll-indicator-panel"
  *ngIf="hasJobs && !minimized"
  aria-live="polite"
  aria-label="Searches still fetching data"
>
  <div class="poll-indicator-header">
    <span class="poll-indicator-pulse" aria-hidden="true"></span>
    <span class="poll-indicator-title">Fetching data</span>
    <span class="poll-indicator-count" *ngIf="jobs.length > 1">{{ jobs.length }}</span>
    <button
      type="button"
      class="poll-indicator-toggle"
      (click)="minimize($event)"
      title="Minimize"
      aria-label="Minimize search queue"
    >
      <span aria-hidden="true">−</span>
    </button>
  </div>
  <ul class="poll-indicator-list">
    <li
      class="poll-indicator-item"
      *ngFor="let job of jobs"
      (click)="onJobClick(job)"
      [attr.title]="job.label || job.job_id"
    >
      <div class="poll-indicator-meta">
        <span class="poll-indicator-service">{{ getServiceLabel(job) }}</span>
        <span class="poll-indicator-username">{{
          job.label || job.job_id
        }}</span>
        <span class="poll-indicator-caption">
          {{ getCaption(job) }}
          <span class="poll-indicator-inline-dot" aria-hidden="true"></span>
          <strong *ngIf="hasProgress(job)">{{ getProgressLabel(job) }}</strong>
          <span
            *ngIf="!hasProgress(job)"
            class="poll-indicator-spinner"
            aria-label="Loading"
            role="status"
          ></span>
        </span>
      </div>
    </li>
  </ul>
</aside>

<!-- Minimized footer bar -->
<button
  type="button"
  class="poll-indicator-footer"
  *ngIf="hasJobs && minimized"
  (click)="expand()"
  aria-live="polite"
  aria-label="Expand search queue"
  title="Expand search queue"
>
  <span class="poll-indicator-pulse" aria-hidden="true"></span>
  <span class="poll-indicator-footer-text">
    Fetching data
    <span class="poll-indicator-footer-count">{{ jobs.length }}</span>
  </span>
  <span class="poll-indicator-footer-expand" aria-hidden="true">▴</span>
</button>
